import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { debounce } from 'lodash-es';

import { receive, toggle } from '../Actions/Cart.action';
import { catchError } from '../Actions/Error.action';
import { loadError, update } from '../Actions/Cart.action';
import { translate } from '../Services/translation';
import Notification from './Notification';
import { add } from "../Services/Cart.service";
import CartItem from "./CartItem";

const MiniCart = () => {
    const dispatch = useDispatch();
    const {
        quantity,
        orderTotal,
        checkoutUrl,
        showInfo,
        orderRows,
    } = useSelector((state) => state.cart);

    const [isResizing, setIsResizing] = useState(false);
    const [latestRemoved, setlatestRemoved] = useState(null);
    const [showNotification, setShowNotification] = useState(false);
    const [showError, setShowError] = useState(false);

    useEffect(() => {
        let resizeTimer;

        const handleResizeStart = () => {
            setIsResizing(true);
            clearTimeout(resizeTimer);

            // Set a timer to check if resizing has stopped after 200 milliseconds
            resizeTimer = setTimeout(() => {
                setIsResizing(false);
            }, 200);
        };

        // Add event listener for window resize start
        window.addEventListener('resize', handleResizeStart);

        // Clean up the event listener and timer on component unmount
        return () => {
            window.removeEventListener('resize', handleResizeStart);
            clearTimeout(resizeTimer);
        };
    }, []);

    const onToggle = () => dispatch(toggle());

    const mapCartToAbort = {};


    const handleRemoveProduct = (item) => {
        setlatestRemoved(item);
        dispatch(
            update(item.rowSystemId, 0, mapCartToAbort[item.rowSystemId])
        )
            .then((response) => setShowNotification(true))
            .catch((ex) => {
                setShowError(true);
                dispatch(catchError(ex, (error) => loadError(error)));
                setTimeout(() => {
                    setShowError(false);
                }, '2500');
            });
    };

    const undoRemoveProduct = () => {
        add({
                articleNumber: latestRemoved.articleNumber,
                quantity: latestRemoved.quantity,
            }
        )
            .then((cart) => dispatch(receive(cart)))
            .catch((ex) => {
                setShowError(true);
                dispatch(catchError(ex, (error) => loadError(error)));
            });
        setShowNotification(false);
    };

    return (
        <div className="cart cart--mini">
            <a
                className="cart__link--block"
                rel="nofollow"
                href="#"
                onClick={(e) => {
                    e.preventDefault();
                    onToggle();
                }}
            >
                <span className="cart__icon-container">
                    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                        <g stroke="var(--navigation-icon-color, #FFFFFF)" strokeLinecap="round" strokeLinejoin="round"
                           strokeWidth="1.5">
                            <path
                                d="m3.5 5.66614-2.5 3.33333v11.66663c0 .4421.17559.866.48816 1.1785.31256.3126.73648.4882 1.17851.4882h11.66663c.4421 0 .866-.1756 1.1785-.4882.3126-.3125.4882-.7364.4882-1.1785v-11.66663l-2.5-3.33333z"/>
                            <path d="m1 8.99976h15"/>
                            <path
                                d="m11.8329 12.335c0 .884-.3512 1.7319-.9763 2.357s-1.47295.9763-2.35701.9763c-.88405 0-1.7319-.3512-2.35702-.9763s-.97631-1.473-.97631-2.357"/>
                        </g>
                    </svg>
                    <div className="cart__quantity-container">
                        <span className="cart__quantity">{quantity}</span>
                    </div>
                </span>

                <span className="cart__title hide">
                    {translate('minicart.checkout')}
                </span>
            </a>
            <div
                className={`cart__info 
                ${!showInfo ? 'cart__info--hidden' : 'cart__info--visible'} 
                ${isResizing ? 'cart__info--no-animation' : ''}`}
            >
                <div className="cart__content">
                    <div className="cart__content__top">
                        <p className="cart__content__top__title">
                            {translate('minicart.title')}
                        </p>
                        <span
                            className="cart__content__top__close-button"
                            onClick={() => onToggle()}
                        ></span>
                    </div>
                    {Object.keys(orderRows).length < 1 && (
                        <div className="cart__content__item">
                            <p>{translate('minicart.empty')}</p>
                        </div>
                    )}
                    <div className="cart__content__item__container">
                        {orderRows &&
                            orderRows.map((item, index) => (
                                <CartItem
									key={index}
                                    item={item}
                                    handleRemoveProduct={handleRemoveProduct}
                                    setShowError={setShowError}/>
                            ))}
                    </div>
                    <div className="cart__sum">
                        {!showError && latestRemoved && showNotification && (
                            <Notification
                                info={true}
                                text={`${latestRemoved.name} ${translate(
                                    'minicart.productremoved'
                                )}`}
                                buttonText={translate('minicart.undo')}
                                onClick={() => undoRemoveProduct()}
                            />
                        )}
                        {/*{showError && (*/}
                        {/*    <Notification text={translate('tooltip.error')}/>*/}
                        {/*)}*/}
                        <div className="cart__sum__total">
                            <p>{translate('minicart.total')}</p>
                            <p>{orderTotal}</p>
                        </div>
                        <p className="cart__sum__info">
                            {translate('minicart.shippinginfo')}
                        </p>

                        <div className="cart__sum__checkout">
                            <button>
                                <a href={checkoutUrl}>
                                    {translate('minicart.checkout')}
                                </a>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MiniCart;
